export default __webpack_public_path__ + "static/media/Confirmation.486c3131.png";